import { ApolloClient, NormalizedCacheObject } from 'apollo-boost'

import { SearchQueryVariables } from '@thg-commerce/enterprise-components/Header/HeaderSearchForm/types'

import { Maybe, MoneyValue, ProductPrice } from '../../../generated/graphql'
import { instantSearch } from '../../../graphql/Query/InstantSearch/InstantSearch.graphql'
import { ClientBehaviours } from '../../utils'

export const InstantSearch = (
  client: ApolloClient<NormalizedCacheObject>,
  { behaviours }: { behaviours: ClientBehaviours },
) => async (_, args: SearchQueryVariables) => {
  if (behaviours.override) {
    const { instantSearchMockWithVariables }: any = await import(
      '../../data/InstantSearch'
    )
    return {
      ...instantSearchMockWithVariables(args),
      products: formatProductsWithPrice(
        instantSearchMockWithVariables(args).products,
      ),
    }
  }

  if (!args.query) {
    return {}
  }

  const { data, errors } = await client.query({
    query: instantSearch,
    variables: args,
  })
  const searchData = data
    ? {
        ...data['instantSearch'],
        errors,
        __typename: 'Query',
      }
    : null

  return {
    ...searchData,
    products: formatProductsWithPrice(searchData?.products),
  }
}

export const formatProductsWithPrice = (
  products:
    | {
        cheapestVariant: {
          price?: ProductPrice
          vipPrice?: MoneyValue
        } | null
        mostExpensiveVariant: {
          price?: ProductPrice
          vipPrice?: MoneyValue
        } | null
        variants: {
          price: ProductPrice
        }[]
      }[]
    | undefined
    | null,
) => {
  if (!products) {
    return []
  }

  return products.map((product) => {
    return {
      ...product,
      price: {
        ...getProductPrice(
          product.cheapestVariant,
          product.mostExpensiveVariant,
        ),
        __typename: 'Price',
      },
    }
  })
}

export const getProductPrice = (
  cheapestVariant:
    | {
        price?: ProductPrice
        vipPrice?: Maybe<MoneyValue>
      }
    | null
    | undefined,
  mostExpensiveVariant:
    | {
        price?: ProductPrice
        vipPrice?: Maybe<MoneyValue>
      }
    | null
    | undefined,
) => {
  if (!cheapestVariant && !mostExpensiveVariant) {
    return {}
  }

  const lowestPrice = cheapestVariant?.price?.price?.amount || '0'
  const highestPrice = mostExpensiveVariant?.price?.price?.amount || '0'
  const lowestVipPrice = cheapestVariant?.vipPrice?.amount || '0'
  const highestVipPrice = mostExpensiveVariant?.vipPrice?.amount || '0'

  const hasFromPrice =
    lowestVipPrice < highestVipPrice || lowestPrice < highestPrice

  return {
    hasFromPrice,
    price: {
      displayValue: cheapestVariant?.vipPrice
        ? cheapestVariant?.vipPrice.displayValue
        : cheapestVariant?.price?.price?.displayValue,
      amount: cheapestVariant?.vipPrice
        ? cheapestVariant?.vipPrice.amount
        : cheapestVariant?.price?.price?.amount,
      __typename: 'MoneyValue',
    },
    rrp: {
      displayValue: cheapestVariant?.price?.rrp?.displayValue,
      amount: cheapestVariant?.price?.rrp?.amount,
      __typename: 'MoneyValue',
    },
  }
}
